import React from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
  children: React.ReactNode;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  error,
  children
}) => {
  return (
    <div className="form-field checkbox-field">
      <label className="checkbox-container">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="checkmark"></span>
        <span className="checkbox-label">{children}</span>
      </label>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Checkbox; 